module.exports = __webpack_public_path__ + "static/img/about12.5a3e147.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about12.png
// module id = rlKw
// module chunks = 1